import {TagType, entities} from '../../../util/uiconstants';
import {currentResource} from '../../../util/utils';
export const SampleItemFilterConfiguration = {
	tags: {
		endpoint: 'tags',
		entityFilter: (entityFilters) => ({
			engagementId: entityFilters.engagementId,
			entityId: entities.SampleItem,
			filterTagCategory: TagType.FilteringNotArchived
		}),
		entityMapping: (response) => {
			let tags = response?.data
				?.filter((x) => x.engagementTagId)
				.sort(function(a, b) {
					return (
						(a.engagementTagGroupName ?? '').localeCompare(b.engagementTagGroupName ?? '') ||
						(a.engagementTagName ?? '').localeCompare(b.engagementTagName ?? '')
					);
				})
				.map((item) => ({
					value: '#' + item.engagementTagId.toString(),
					label: item.engagementTagName,
					group: item.engagementTagGroupName
				}));

			return tags;
		},
		getDisplayValue: (id, entityType, _filterData) => {
			let value;

			if (_filterData?.store && _filterData?.store[entityType].byId && _filterData?.store[entityType].byId[id]) {
				value = _filterData?.store[entityType]?.byId[id].label;
			}

			return value;
		}
	}
};

export const ControlFilterConfiguration = {
	controls: {
		endpoint: 'controls',
		entityMapping: (response) => {
			return response?.data
				.sort((a, b) => a.controlName.localeCompare(b.controlName))
				.map((item) => ({
					value: item.id.toString(),
					label: item.controlName
				}));
		},
		getDisplayValue: (id, entityType, _filterData) => {
			return _filterData?.store[entityType]?.byId[id]?.label;
		}
	},
	filterHasAnyRiskRequiredControls: {
		getDisplayValue: (value) => {
			return currentResource.yesNoOptions.find((item) => Boolean(item.value) === value)?.label;
		}
	}
};

export const FilterEntityConfiguration = {
	...SampleItemFilterConfiguration,
	...ControlFilterConfiguration
};
